module.exports = __webpack_public_path__ + "assets/RetinaNarr-Bold.1e2cba1400e0fea01e7634dc03f91399.woff2";